export const fibonacciDocs = 'https://fibonacci-docs.exoai.tech/docs/intro';
export const exoaiSupportMail = 'support@exoai.tech';
export const termOfService = 'https://www.exoai.tech/term-services';
export const privacyPolicy = 'https://www.exoai.tech/privacy-policy';
